/* eslint-disable no-prototype-builtins */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
import Toasty from 'components/atoms/Toasty';
import { globalId } from 'index';
import { NativeSupportHandlerLegacy, NativeSupportHandlerV2 } from '@bharatpe/native-support-handler';
import { CancelPaymentApi } from 'Services';
import {
	TOKEN_SESSION_KEY,
	LATITUDE,
	LONGITUDE,
	LANGUAGE,
	PERMISSIONS,
	REDIRECT_URI_DEEPLINK,
	LOCALE,
} from './CONSTANT';
import { loadState, saveState } from './LocalStorage';
import { isProd, showUnityUi } from './Utils';
import { IAppInfo } from 'types';
import { sendRawNativeData, sendRawNativeDataUpi } from './nativeUpiHandler';
import { IGetParams } from 'api';
export const getURLParameter = (qrString: string, paramName: string) => {
	const qr = qrString.replace(/[[]/, '\\[').replace(/[\]]/, '\\]');
	const regex = new RegExp(`[\\?&]${paramName}=([^&#]*)`);
	const results = regex.exec(qr);

	return results && results.length > 0 ? decodeURIComponent(results[1].replace(/\+/g, ' ')) : '';
};

export const getAppInfo = (): IAppInfo => {
	const appInfoParsed: any = loadState('APP_INFO');
	const userAgent = window.navigator.userAgent.toLowerCase();
	const appInfo = {
		token: getURLParameter(window.location.href, 'token') || getURLParameter(window.location.href, 'visa'),
		latitude: getURLParameter(window.location.href, 'latitude') || '',
		longitude: getURLParameter(window.location.href, 'longitude') || '',
		language: getURLParameter(window.location.href, 'language') || '',
		Authorization: `bearer ${
			getURLParameter(window.location.href, 'token') || getURLParameter(window.location.href, 'visa')
		}`,
		Entity: getURLParameter(window.location.href, 'entity') || '',
		device: getURLParameter(window.location.href, 'deviceId') || appInfoParsed?.deviceId || '',
		simid: getURLParameter(window.location.href, 'simId') || appInfoParsed?.simId || '',
		installid: getURLParameter(window.location.href, 'installId') || appInfoParsed?.installId || '',
		platform: userAgent?.includes('android') ? 'android' : 'ios',
		appversion: getURLParameter(window.location.href, 'appversion') || appInfoParsed?.appversion || '',
	};

	return appInfo;
};

export const initNativeSupport = async () => {
	await NativeSupportHandlerV2.init();
	const appInfo = await NativeSupportHandlerLegacy.getAppInfo();
	subScribeBackButton();
	const token = getURLParameter(window.location.href, 'token') || getURLParameter(window.location.href, 'visa');
	const latitude = getURLParameter(window.location.href, 'latitude');
	const longitude = getURLParameter(window.location.href, 'longitude');
	const language = getURLParameter(window.location.href, 'language');
	const redirectURIDeeplink = getURLParameter(window.location.href, 'redirectURIDeeplink');
	const locale = getURLParameter(window.location.href, 'locale');
	saveState('APP_INFO', JSON.parse(appInfo));
	saveState(TOKEN_SESSION_KEY, token);
	saveState(LATITUDE, latitude);
	saveState(LONGITUDE, longitude);
	saveState(LANGUAGE, language);
	saveState(REDIRECT_URI_DEEPLINK, redirectURIDeeplink);
	saveState(LOCALE, locale);
};

export const closeNativeSupport = () => {
	NativeSupportHandlerV2.closeWebView()
		.then((res) => console.log(res)) // eslint-disable-line no-console
		.catch((err) => console.error(err)); // eslint-disable-line no-console
};

/**
 * @function subscribeBackButton
 * @description init native back button functionality
 */
const subScribeBackButton = async () => {
	try {
		await NativeSupportHandlerV2.subscribeBackPress(backPressSuccessAction, backPressFailAction);
	} catch (error) {
		console.log(error);
	}
};

const TriggerCancelPaymentApi = () => {
	CancelPaymentApi({ txnId: globalId })
		.then((resp: any) => {
			redirectToSource();
		})
		.catch((err) => {
			redirectToSource();
			Toasty.error('Something went wrong');
		});
};

const handleBack = () => {
	const paymentStatusSaved = loadState('paymentStatusSaved', true);
	if (paymentStatusSaved === 'INIT') {
		TriggerCancelPaymentApi();
		return;
	}
	redirectToSource();
};

const redirectToSource = () => {
	const deviceType = loadState('deviceType', true);
	const backUri: string = loadState('backUri', true) || '';
	const backUriDeeplink: string = loadState('backUriDeeplink', true) || '';
	if (deviceType === 'webview') {
		if (backUriDeeplink) {
			NativeSupportHandlerV2.openDeeplink(backUriDeeplink);
			return;
		}
		NativeSupportHandlerV2.closeWebView();
	}
	if (deviceType === 'browser') {
		window.open(backUri, '_top');
		return;
	}
	NativeSupportHandlerV2.closeWebView();
};

export const customSubScribeBackButton = async (onBack?: any) => {
	try {
		await NativeSupportHandlerV2.subscribeBackPress(() => backPressSuccessAction(onBack), backPressFailAction);
	} catch (error) {
		console.log(error);
	}
};

const backPressSuccessAction = (onBack?: any) => {
	if (onBack) {
		onBack();
		return;
	}
	if (window.location.hash === '#/' || window.location.hash === '#/juspay-bharatpe-landing') {
		handleBack();
	} else if (window.location.hash === '#/check-status') {
		redirectToSource();
	} else if (
		window.location.hash === '#/thanks' ||
		window.location.hash === '#/account/upi-settings' ||
		window.history.length == 1
	) {
		closeNativeSupport();
	} else {
		window.history.back();
	}
};

const backPressFailAction = () => {
	console.log('back failed');
};

declare global {
	interface Window {
		androidObj: any;
	}
}

// eslint-disable-next-line @typescript-eslint/no-empty-function
//window.androidObj = function AndroidClass() {};
export const showPostpeLoader = (props: any) => {
	const nativeData = { ...props };
	nativeData['key'] = 45;
	const unityNativeData = {
		key: 45,
		json: {},
	};
	const unityPayload = { ...props };
	unityNativeData.json = JSON.stringify(unityPayload);
	const isShowUnity = showUnityUi();
	if (isShowUnity && window.androidObj && window.androidObj.nativeSupport) {
		window.androidObj.nativeSupport(JSON.stringify(unityNativeData));
		return;
	}
	if (window.androidObj && window.androidObj.nativeSupport) {
		window.androidObj.nativeSupport(JSON.stringify(nativeData));
	}
};

export const removePostpeLoader = () => {
	const nativeData = {
		key: 46,
	};
	if (window.androidObj && window.androidObj.nativeSupport) {
		window.androidObj.nativeSupport(JSON.stringify(nativeData));
	}
	return;
};

export const checkPermissions = async () => {
	try {
		const data = await NativeSupportHandlerLegacy.checkPermissionStatus(PERMISSIONS);
		return JSON.parse(data);
	} catch (error: any) {
		Toasty.error(error);
	}
};

export const SavePermissions = async (permission: string[]) => {
	try {
		const savedPermission = await NativeSupportHandlerLegacy.requestPermissions(permission);
		console.log(savedPermission);
		return JSON.parse(savedPermission);
	} catch (error: any) {
		Toasty.error(error);
	}
};
export const OpenAppSettings = async () => {
	try {
		const request = {
			key: 207,
		};
		await window.androidObj.nativeSupport(JSON.stringify(request));
	} catch (error: any) {
		Toasty.error(error);
	}
};

export const copyToClipboard = async (data: any) => {
	const request = {
		key: 61,
		copyText: data.code,
		label: data.lable,
		msgText: data.msgText,
	};
	await window.androidObj.nativeSupport(JSON.stringify(request));
};

export const sendCleverTapEvent = (eventName: string, eventParams: IGetParams): void => {
	if (isProd()) {
		try {
			NativeSupportHandlerLegacy.cleverTrackEvent(eventName, eventParams);
		} catch (error) {
			console.error(error);
		}
	}
};
